export default __webpack_public_path__ + "static/media/sb-ICO-010.7d0e8b09.webp";